import React, { useState, useEffect } from "react";
import { useLoadingSelector, useUserInfoSelector } from "store/reducers";
import "./Loading.css";
import Lottie from "lottie-react";
import loadingBliss from "../../../assets/JsonAnimations/loadingBliss.json";
import loadingAnimation from "../../../assets/JsonAnimations/loadingAnimation.json";

const loadingAffirmations = [
  "You are enough. Always.",
  "Focus on Progress, not perfection.",
  "Your feelings are valid.",
  "Breathe in calm, breathe out stress.",
  "Don't rush, One step at a time.",
  "You've got this!",
  "You are growing every day.",
  "Be gentle with yourself.",
  "This too shall pass.",
  "Small wins are still wins.",
  "Kindness starts within.",
  "Rest is productive.",
  "You deserve peace.",
  "Choose compassion today.",
  "You shine from within.",
  "Everything starts with a deep breath.",
  "You’re doing better than you think.",
  "Choose to see the good in yourself.",
  "Inhale calm, exhale worry.",
  "This moment is safe.",
  "Peace is within You.",
  "Allow yourself to slow down.",
  "You are capable and strong.",
  "It’s okay to take time.",
  "Good things are coming.",
  "Today holds new possibilities.",
  "There’s light in every moment.",
  "Joy finds You easily.",
  "Hope is Your anchor.",
];

const Loading = ({ show }) => {
  const isLoading = useLoadingSelector();
  const userInfo = useUserInfoSelector();
  const [currentAffirmation, setCurrentAffirmation] = useState("");

  const isCurrentlyLoading = show || isLoading;

  const  getFirstName = (fullName) => {
    return fullName?.split(' ')?.[0];
}

  useEffect(() => {
    let intervalId;

    const getRandomAffirmation = () => {
      const randomIndex = Math.floor(Math.random() * loadingAffirmations.length);
      let affirmationText = loadingAffirmations[randomIndex];
      if (userInfo && userInfo.fullName) {

        const firstName = getFirstName(userInfo.fullName);
        affirmationText = `${firstName}, ${
          affirmationText.charAt(0).toLowerCase() + affirmationText.slice(1)
        }`;
      }
      return affirmationText;
    };

    if (isCurrentlyLoading) {
      setCurrentAffirmation(getRandomAffirmation());

      intervalId = setInterval(() => {
        setCurrentAffirmation(getRandomAffirmation());
      }, 600000);
    } else {
      setCurrentAffirmation("");
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [isCurrentlyLoading, userInfo]);

  return (
    <div
      className={`fp-container-bliss ${
        !isCurrentlyLoading ? "fp-container-bliss-hidden" : ""
      }`}
    >
      <Lottie
        animationData={loadingAnimation}
        style={{ height: "200px", width: "500px" }}
        loop={true}
        className="fp-loader-bliss"
      />
      {isCurrentlyLoading && currentAffirmation && (
        <p className="affirmation-text">
          {currentAffirmation}
        </p>
      )}
    </div>
  );
};

export default Loading;